// @ts-strict-ignore
import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LinkImpersonation = lazy(() =>
  import("@scenes/LinkImpersonation/LinkImpersonation").then((module) => ({ default: module.LinkImpersonation }))
);

export const linkImpersonationNRO: NavigationRoutingObject = {
  Component: LinkImpersonation,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "braze-tools",
  heading: (t: I18nT<"dashboard-navigation">) => t("link-impersonation-sidebar-menu-item", "Link Impersonation"),
  pageNameForTracking: () => "Link Impersonation",
  // /* TODO: use technical-writer-approved text for description*/
  description: (t: I18nT<"dashboard-navigation">) =>
    t("link-impersonation-description-nav", "Manage or cancel impersonation"),
  icon: "nav-system-link-impersonation",
  getDeveloperNavigationAllowed: ({
    canImpersonate,
    dashboardImpersonationLink,
    impersonationCompany,
    featureOn,
  }) => {
    return (
      featureOn("impersonation_link_modal") && dashboardImpersonationLink && impersonationCompany && canImpersonate
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
